export const headlessCMSProduct = {
  name: 'Content Hub ONE',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'New way of managing your content! Content Hub ONE is the most flexible, fast and secure way of producing and distributing the content.',
  baseUrl: {
    dev: 'https://content-dev.sitecore-staging.cloud',
    qa: 'https://content-qa.sitecore-staging.cloud',
    staging: 'https://content-staging.sitecore-staging.cloud',
    'pre-production': 'https://content-beta.sitecorecloud.io',
    production: 'https://content.sitecorecloud.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantName={tenantName}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'tenantName',
        source: {
          resource: 'tenant',
          jsonPath: '$.name',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://mss-p-006-delivery.stylelabs.cloud/api/public/content/ad13eb9aaebc4d24a3921fff59051fb7',
  },
  color: 'teal',
  openInTab: true,
};
